import LoginButton from "common/Auth/AuthButton";
import Button from "Components/Button";
import TextArea from "Components/TextArea";
import { FC } from "react";
import { CommentContainer } from "../../../../Auth/Auth.styled";
import { ActionWrapper } from "./Actions.styled";

interface Props {
  addComment: any;
  session: any;
  body: any;
  handleBodyChange: any;
  cancelPost: any;
  commentCount: number;
}

const Actions: FC<Props> = ({
  addComment,
  session,
  body,
  handleBodyChange,
  cancelPost,
  commentCount,
}) => {
  const hasComments = commentCount > 0;
  const hasMultipleComments = commentCount > 1;

  return (
    <ActionWrapper id="comments">
      <h3>Comments</h3>

      {!session ? (
        <CommentContainer className="no-comment-container">
          <p>
            {hasComments
              ? `This article has ${commentCount} comment${
                  hasMultipleComments ? "s" : ""
                }.`
              : "This article has no comments yet. Be the first to leave a comment."}
          </p>
          <LoginButton className="comment-login" type="login">
            Comment
          </LoginButton>
        </CommentContainer>
      ) : (
        <>
          <TextArea
            handleChange={handleBodyChange}
            value={body}
            type="comment"
            placeholder="Insert your comment"
          />
          <div className="button_wrapper">
            <Button
              disabled={body === ""}
              handleClick={cancelPost}
              buttonStyles="frost"
            >
              Cancel
            </Button>
            &nbsp;
            <Button
              disabled={body === ""}
              handleClick={addComment}
              buttonStyles="primary"
            >
              Post
            </Button>
          </div>
        </>
      )}
    </ActionWrapper>
  );
};

export default Actions;
